module.exports = __webpack_public_path__ + "static/img/item_j_lemonade.4088d29.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/item_j_lemonade.png
// module id = BMTM
// module chunks = 1